import React, { useState } from 'react';
import RulesListItem, { RuleListItem } from './rules-list-item';
import { Input } from 'antd';
import { useDebounce } from '../../../custom-hooks/use-debounce/use-debounce';

interface Props {
	ruleListItems: RuleListItem[];
	translations: Translations;
	onAdd: () => void;
	onDelete: (id: string) => void;
	onToggle: (id: string) => void;
	onClick: (id: string) => void;
	readOnly?: boolean;
}

interface Translations {
	filterTeams: string;
	header: string;
	add: string;
	teams: string;
	merchantLevel: string;
	more: string;
}

const RulesList: React.FC<Props> = ({ ruleListItems, onDelete, onAdd, onToggle, onClick, translations, readOnly }) => {
	const [filter, setFilter] = useState('');
	const debouncedFilter = useDebounce(filter, 250);

	return (
		<div className="rules-list">
			<div className="list-header">
				<div className="rule-name-column">{translations.header}</div>
				<div className="rule-name-column">{translations.teams}</div>
				{!readOnly && (
					<div className="add-button" onClick={onAdd}>
						{translations.add}
					</div>
				)}
			</div>
			<div className="rules-list-content">
				<div className="rules-filter list-item">
					<Input.Search
						className="rules-filter-input"
						placeholder={translations.filterTeams}
						onChange={e => {
							setFilter(e.target.value);
						}}
						value={filter}
					/>
				</div>
				{ruleListItems
					.filter(item => filterItem(item, debouncedFilter))
					.map(ruleListItem => {
						return (
							<RulesListItem
								key={ruleListItem.id}
								ruleListItem={ruleListItem}
								isButtonsDisabled={readOnly}
								translations={{ merchantLevel: translations.merchantLevel, more: translations.more }}
								onDelete={() => onDelete(ruleListItem.id)}
								onToggle={() => onToggle(ruleListItem.id)}
								onClick={() => onClick(ruleListItem.id)}
							/>
						);
					})}
			</div>
		</div>
	);
};

export const filterItem = (item: RuleListItem, filter: string): boolean => {
	if (!filter) {
		return true;
	}
	if (item.isMerchantLevel) {
		return true;
	}
	for (const team of item.teams) {
		if (team?.toLowerCase().includes(filter?.toLowerCase())) {
			return true;
		}
	}
	return false;
};

export default RulesList;
